import React from 'react';

const TextBoxArea = React.forwardRef((props, ref) => {
  const {
    className,
    id,
    value,
    onChange,
    labelLocale,
    disabled
  } = props;
  const dataPath = props["data-path"];
  return (
    <label className={"custom-input " + (className ? " " + className : "")}>
      <textarea 
        className="text_area_input"
        id={id}
        data-path={dataPath}
        onChange={onChange}
        value={value || ""}
        placeholder={ labelLocale || ""}
        disabled={disabled}
      />
    </label>
  );
});

export default TextBoxArea;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/textBoxArea.jsx